import { useCallback } from 'react';
import { useAnalytics } from '../../../../common/analytics';
import { onCardRequestFailed } from '../../../../common/analytics/events';
const cards = new Map();
export const useTrelloCard = () => {
  const {
    fireAnalyticsEvent
  } = useAnalytics();
  const loadCard = useCallback(async cardId => {
    try {
      const response = await fetch(`/1/card/${cardId}?fields=name,closed,url,cover,labels,idAttachmentCover&attachments=cover`);
      if (response.ok) {
        const cardResponse = await response.json();
        cards.set(cardId, cardResponse);
        return cardResponse;
      } else {
        throw new Error(`Invalid response: ${response === null || response === void 0 ? void 0 : response.status}`);
      }
    } catch (e) {
      if (e instanceof Error) {
        fireAnalyticsEvent({
          ...onCardRequestFailed({
            attributes: {
              errorMsg: e === null || e === void 0 ? void 0 : e.message,
              errorName: e === null || e === void 0 ? void 0 : e.name
            }
          })
        });
      }
    }
  }, [fireAnalyticsEvent]);
  const getCard = useCallback(async cardId => {
    return cards.get(cardId) ? Promise.resolve(cards.get(cardId)) : loadCard(cardId);
  }, [loadCard]);
  return {
    getCard
  };
};